import { createStore, applyMiddleware, compose } from 'redux';
import { assert, assertString, assertFunction } from '@Utils/assert';
import Middlewares from '@Middlewares';
import createReducer from '@Reducers';
import saveStoreBeforeUnload from './SaveStoreBeforeUnload';

const composeEnhancers = (__DEV__ && window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(createReducer(), composeEnhancers(applyMiddleware(...Middlewares)));

store.asyncReducers = {};

store.injectReducer = (key, reducer) => {
  assertString(key, 'key');
  assertFunction(reducer, 'reducer');

  if (store.asyncReducers[key]) {
    assert(store.asyncReducers[key] === reducer, 'key for reducer has to be unique and reducer for key has to be singleton');

    return store;
  }

  store.asyncReducers[key] = reducer;
  store.replaceReducer(createReducer(store.asyncReducers));

  return store;
};

if (__DEV__) {
  window.store = store;
}

saveStoreBeforeUnload(store);

export default store;
